import React, { useState, useRef } from "react";
import Topbar from "../components/Menu/Topbar";
import Header from "../components/Menu/Header";
import Footer from "../components/Menu/Footer";
import Favicon from "../components/Head/Faviconscript";
import { Outfit } from "next/font/google";

const outfit = Outfit({
  subsets: ["latin"],
  variable: "--font-outfit",
  display: "swap",
  weight: ["400", "500", "600", "700"],
  preload: true,
  fallback: ["system-ui", "arial"],
  adjustFontFallback: true,
});
export default function DefaultLayout({ children, websiteData }) {
  return (
    <div className={outfit.className}>
      {/* {JSON.stringify(websiteData)} */}

      <Favicon
        favicon={websiteData?.website?.favicon}
        scripts={websiteData?.website?.script}
      />
      {websiteData && (
        <>
          {/* <Topbar topNav={websiteData} /> */}
          <Header topNav={websiteData}  />
        </>
      )}

      <main>{children}</main>
      {websiteData && <Footer footerData={websiteData} />}

    </div>
  );
}
